import * as React from "react";

import { getSetDeductible } from "../boatUtils";

import { StyledAlert } from "App/global-style";
import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { Select } from "Components/Form/Select";
import { useTexts } from "Components/TextContext";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { BoatCoverage } from "Store/interfaces/products/coverage";
import { isDefined } from "Utils/functions";
import type { FormikProps } from "formik";
import { getDeductibles } from "../../vehicleUtils";
import { BoatProductPriceFormValues } from "./boatProductPriceInterfaces";

interface Props {
  formProps: FormikProps<BoatProductPriceFormValues>;
  coverages: CoveragePriceCalculation[];
}

const deductibleFieldName = "deductible";

export const BoatDeductible = (props: Props): React.ReactElement => {
  const { formProps, coverages } = props;
  const coverage = formProps.values.coverage;
  const deductible = formProps.values.deductible;
  const setDeductible = getSetDeductible(coverage);
  const { getText } = useTexts();
  const deductibleAlertTitle = getText("boatform.alerttitle.deductible");

  React.useEffect(() => {
    if (isDefined(setDeductible)) {
      formProps.setFieldValue(deductibleFieldName, setDeductible);
    }
  }, [coverage, setDeductible, deductible]);

  if (coverage === BoatCoverage.BOAT_ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE) {
    return (
      <StyledAlert
        alertId={deductibleFieldName}
        title={deductibleAlertTitle}
        fluid
      >
        {getText(
          "boatform.alertdescription.deductible-boat_rowboat_canoe_kayak_full_own_damage",
        )}
      </StyledAlert>
    );
  }

  if (
    coverage === BoatCoverage.BOAT_SAILING_BOAT_REDUCED_OWN_DAMAGE ||
    coverage === BoatCoverage.BOAT_MOTOR_REDUCED_OWN_DAMAGE
  ) {
    return (
      <StyledAlert
        alertId={deductibleFieldName}
        title={deductibleAlertTitle}
        fluid
      >
        {getText(
          "boatform.alertdescription.deductible-boat_sailing_boat_reduced_own_damage",
        )}
      </StyledAlert>
    );
  }

  if (coverage === BoatCoverage.BOAT_ROWBOAT_CANOE_KAYAK_REDUCED_OWN_DAMAGE) {
    return (
      <StyledAlert
        alertId={deductibleFieldName}
        title={deductibleAlertTitle}
        fluid
      >
        {getText(
          "boatform.alertdescription.deductible-boat_rowboat_canoe_kayak_reduced_own_damage",
        )}
      </StyledAlert>
    );
  }

  const deductibleOptions = getDeductibles(
    INSURANCE_NAME_VALUE.BOAT,
    coverage,
    coverages,
  );

  return (
    <Select
      id={deductibleFieldName}
      name={deductibleFieldName}
      label={getText("boatform.label.deductible")}
      hint={getText("boatform.hint.deductible")}
      options={deductibleOptions}
      large
    />
  );
};
